import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SizeUnit } from '@features/file-explorer/components/Toolbar/filterTypes'
import { convertSizeToBytes } from './sizeUtils'

interface SizeFilterInputProps {
  onSubmit: (value: string, valueLabel: string) => void
}

export function SizeFilterInput({ onSubmit }: SizeFilterInputProps) {
  const { t } = useTranslation()
  const [filterValue, setFilterValue] = useState('')
  const [sizeUnit, setSizeUnit] = useState<SizeUnit>('MB')

  const handleSubmit = () => {
    if (!filterValue) return

    const actualValue = convertSizeToBytes(filterValue, sizeUnit)
    const valueLabel = `${filterValue} ${t(`fileExplorer.filters.units.${sizeUnit}`)}`
    onSubmit(actualValue, valueLabel)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <>
      <div className="flex gap-2">
        <input
          type="number"
          value={filterValue}
          onChange={(e) => setFilterValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t('fileExplorer.filters.placeholders.sizeValue')}
          className="input input-bordered input-sm flex-1"
          autoFocus
        />
        <select
          value={sizeUnit}
          onChange={(e) => setSizeUnit(e.target.value as SizeUnit)}
          className="select select-bordered select-sm w-20"
        >
          <option value="B">{t('fileExplorer.filters.units.B')}</option>
          <option value="KB">{t('fileExplorer.filters.units.KB')}</option>
          <option value="MB">{t('fileExplorer.filters.units.MB')}</option>
          <option value="GB">{t('fileExplorer.filters.units.GB')}</option>
          <option value="TB">{t('fileExplorer.filters.units.TB')}</option>
        </select>
      </div>
      <button
        onClick={handleSubmit}
        disabled={!filterValue}
        className="btn btn-primary btn-sm w-full mt-2"
      >
        {t('fileExplorer.filters.addFilter')}
      </button>
    </>
  )
}
